import { isNil } from 'ramda'

import type { ArticleWarningBoxComponent } from '@twisto/api-cms'

import type { RichTextBlock } from 'homepage/components/rich-text/rich-text.d'

import { RichText } from '../../rich-text'

import * as styles from './warning-box.styles'

type WarningBoxProps = ArticleWarningBoxComponent & {
  content?: RichTextBlock[]
}

export const WarningBox = ({ content, background }: WarningBoxProps) => (
  <article
    css={[
      styles.wrapper,
      styles.colors[isNil(background) ? 'neutral' : background],
    ]}
  >
    <RichText input={content} />
  </article>
)
